<template>
  <login-form/>
  <!-- <live-wagering/> -->
  <!-- <agent-button/> -->
</template>

<script>
  import LoginForm from "@/components/login-form.vue"

  export default {
    name: "PageHome",
    components: {
      LoginForm
    },
    setup:() => {
    },
  }
</script>